import type { GridDetailRowProps } from "@tql/ui-components-react/kendo/grid";

import type { ShipmentLineItem } from "~/shared/schemas/shipment-management-schema.ts";

/**
 * Nested grid detail row shown under a freight line item when it is hazmat.
 * Displays the hazmat-specific values (UN number, proper shipping name, hazmat
 * class and packing group). Renders nothing for non-hazmat rows.
 */
export const HazmatDetailRow = (props: GridDetailRowProps) => {
	const item = props.dataItem as ShipmentLineItem;

	if (!item.hazmat) {
		return null;
	}

	return (
		<div className={"hazmat-detail-row"}>
			<div className={"freight-item"}>
				<div className={"freight-label section-label"}>UN Number</div>
				<div className={"freight-value"}>
					{item.hazmatIdentificationNumber || "N/A"}
				</div>
			</div>
			<div className={"freight-item"}>
				<div className={"freight-label section-label"}>
					Proper Shipping Name
				</div>
				<div className={"freight-value"}>
					{item.hazmatProperShippingName || "N/A"}
				</div>
			</div>
			<div className={"freight-item"}>
				<div className={"freight-label section-label"}>Hazmat Class</div>
				<div className={"freight-value"}>{item.hazmatHazardClass || "N/A"}</div>
			</div>
			<div className={"freight-item"}>
				<div className={"freight-label section-label"}>Packing Group</div>
				<div className={"freight-value"}>
					{item.hazmatPackingGroup || "N/A"}
				</div>
			</div>
		</div>
	);
};
